var styleArray_park1 = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#2c2d53"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#e4e4e4"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#2c2d53"
      },
      {
        "saturation": -15
      },
      {
        "lightness": -40
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#4b6878"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#64779e"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.province",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#4b6878"
      }
    ]
  },
  {
    "featureType": "landscape.man_made",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#334e87"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "landscape.natural",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#2c2d53"
      },
      {
        "lightness": -20
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#2c2d53"
      },
      {
        "lightness": -15
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#6f9ba5"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#1d2c4d"
      }
    ]
  },
  {
    "featureType": "poi.business",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#2c2d53"
      },
      {
        "saturation": -25
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#3C7680"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#2c2d53"
      },
      {
        "lightness": 35
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#00a7d8"
      },
      {
        "saturation": -80
      },
      {
        "lightness": 100
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#2c2d53"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#2c2d53"
      },
      {
        "lightness": -30
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#2c2d53"
      },
      {
        "saturation": 20
      },
      {
        "lightness": -35
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#e4e4e0"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#2c2d53"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#98a5be"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#1d2c4d"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#283d6a"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#3a4762"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#0e1626"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#4e6d70"
      }
    ]
  }
];

var styleArray_park2 = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#00a7d8"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#e4e4e4"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#2c2d53"
      },
      {
        "saturation": -15
      },
      {
        "lightness": -40
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#4b6878"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#64779e"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.province",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#4b6878"
      }
    ]
  },
  {
    "featureType": "landscape.man_made",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#334e87"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "landscape.natural",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#00a7d8"
      },
      {
        "saturation": -15
      },
      {
        "lightness": 30
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#00a7d8"
      },
      {
        "lightness": -20
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#6f9ba5"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#1d2c4d"
      }
    ]
  },
  {
    "featureType": "poi.business",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#00a761"
      },
      {
        "saturation": -25
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#3C7680"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#00a7d8"
      },
      {
        "lightness": -25
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#00a7d8"
      },
      {
        "saturation": -80
      },
      {
        "lightness": 100
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#2c2d53"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#00a7d8"
      },
      {
        "lightness": -60
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#3591ff"
      },
      {
        "saturation": 20
      },
      {
        "lightness": -65
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#e4e4e0"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#2c2d53"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#98a5be"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#1d2c4d"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#283d6a"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#3a4762"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#3591ff"
      },
      {
        "lightness": -75
      }
    ]
  }
];

function initMap() {
    var park1_myLatLng = {lat: 51.77430299897345, lng: 19.433000416103416};
    var park1_myCenterLatLng = {lat: 51.7752895, lng: 19.4369655};
    
    var park2_myLatLng = {lat: 51.76345829976914, lng: 19.49232031610317};
    var park2_myCenterLatLng = {lat: 51.76455829976914, lng: 19.49802031610317};
    var tulipan_centerLatLng = {lat: 51.76475829976914, lng: 19.49482031610317};
    
    if (document.getElementById('footer-map-park1') != undefined) {
        var footer_map_park1 = new google.maps.Map(document.getElementById('footer-map-park1'), {
            center: park1_myCenterLatLng,
            zoom: 17,
            panControl: false,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
            },
            scrollwheel: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            styles: styleArray_park1,
        });

        var marker_footer_park1 = new google.maps.Marker({
            icon: new google.maps.MarkerImage('/css/img/pointer.svg', null, null, null),
            position: park1_myLatLng,
            map: footer_map_park1,
            title: 'Saltos - Srebrzyńska'
        });
    }

    if (document.getElementById('footer-map-park2') != undefined) {
        var footer_map_park2 = new google.maps.Map(document.getElementById('footer-map-park2'), {
            center: park2_myCenterLatLng,
            zoom: 17,
            panControl: false,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
            },
            scrollwheel: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            styles: styleArray_park2,
        });

        var marker_footer_park2 = new google.maps.Marker({
            icon: new google.maps.MarkerImage('/css/img/pointer.svg', null, null, null),
            position: park2_myLatLng,
            map: footer_map_park2,
            title: 'Saltos - Wydawnicza'
        });
        var tulipan_marker_footer_park2 = new google.maps.Marker({
            icon: new google.maps.MarkerImage('/css/img/logo-tulipan.svg', new google.maps.Size(155, 75), new google.maps.Point(0, 0), new google.maps.Point(17, 34), new google.maps.Size(100, 50)),
            position: tulipan_centerLatLng,
            map: footer_map_park2,
            title: 'Centrum Handlowe - Tulipan'
        });
    }

    if (document.getElementById('header-map-park1') != undefined) {
        var header_map_park1 = new google.maps.Map(document.getElementById('header-map-park1'), {
            center: park1_myCenterLatLng,
            zoom: 15,
            panControl: false,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
            },
            scrollwheel: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            styles: styleArray_park1,
        });

        var header_marker_park1 = new google.maps.Marker({
            icon: new google.maps.MarkerImage('/css/img/pointer.svg', null, null, null),
            position: park1_myLatLng,
            map: header_map_park1,
            title: 'Saltos - Srebrzyńska'
        });
    }
    if (document.getElementById('header-map-park2') != undefined) {
        var header_map_park2 = new google.maps.Map(document.getElementById('header-map-park2'), {
            center: park2_myCenterLatLng,
            zoom: 15,
            panControl: false,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
            },
            scrollwheel: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            styles: styleArray_park2,
        });

        var header_marker_park2 = new google.maps.Marker({
            icon: new google.maps.MarkerImage('/css/img/pointer.svg', null, null, null),
            position: park2_myLatLng,
            map: header_map_park2,
            title: 'Saltos - Wydawnicza'
        });
        var tulipan_marker_header_park2 = new google.maps.Marker({
            icon: new google.maps.MarkerImage('/css/img/logo-tulipan.svg', new google.maps.Size(155, 75), new google.maps.Point(0, 0), new google.maps.Point(17, 34), new google.maps.Size(70, 35)),
            position: tulipan_centerLatLng,
            map: header_map_park2,
            title: 'Centrum Handlowe - Tulipan'
        });
    }
}